<template>
    <SOSlotBase
        :container-name="`landing-page-komplain-qris`"
        :loading="pageSetting.isLoading"
    >
        <template v-slot:title-bar>
            <SOTitleBar page-title="Detail Komplain" type="back" @back="$router.go(-1)" />
        </template>
        <template v-slot:loading-page>
            <SOLoadingPage />
        </template>
        <template v-if="!pageSetting.isLoading" v-slot:content>
            <div class="">
                <div class="p-4">
                    <div>
                        <svg width="10" height="9" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.77298 1.92558L8.71928 0.243566C8.62512 0.092574 8.45789 3.05176e-05 8.27929 3.05176e-05H1.72007C1.54148 3.05176e-05 1.37425 0.092574 1.28008 0.243566L0.226386 1.92558C-0.31751 2.7942 0.16469 4.00213 1.18105 4.14013C1.25411 4.14988 1.32879 4.15475 1.40347 4.15475C1.88405 4.15475 2.30943 3.94368 2.60167 3.61735C2.89391 3.94368 3.32091 4.15475 3.79986 4.15475C4.28044 4.15475 4.70582 3.94368 4.99806 3.61735C5.2903 3.94368 5.7173 4.15475 6.19625 4.15475C6.67683 4.15475 7.10221 3.94368 7.39445 3.61735C7.68832 3.94368 8.11369 4.15475 8.59264 4.15475C8.66895 4.15475 8.74201 4.14988 8.81507 4.14013C9.83468 4.00376 10.3185 2.79582 9.77298 1.92558ZM8.59589 4.67591C8.43353 4.67591 8.2728 4.65156 8.11694 4.61422V6.23454H1.88243V4.61422C1.72657 4.64994 1.56583 4.67591 1.40347 4.67591C1.30606 4.67591 1.20702 4.66942 1.11123 4.65643C1.02031 4.64344 0.931015 4.62234 0.844966 4.59798V7.79317C0.844966 8.08054 1.07714 8.31271 1.36451 8.31271H8.6381C8.92548 8.31271 9.15765 8.08054 9.15765 7.79317V4.59798C9.06997 4.62396 8.9823 4.64507 8.89138 4.65643C8.79234 4.66942 8.69493 4.67591 8.59589 4.67591Z" fill="#6F7287"/>
                        </svg>
                        <span class="f-12 f-c-midgrey" style="padding-left: 4px;">{{ detailKomplain.actual_data.outlet.nama }}</span>
                    </div>
                    <div class="f-16 f-semi">
                        {{ idTampil }}
                    </div>
                    <div>
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.99967 1.66668C4.05416 1.66668 1.66634 4.05449 1.66634 7.00001C1.66634 9.94553 4.05416 12.3333 6.99967 12.3333C9.94519 12.3333 12.333 9.94553 12.333 7.00001C12.333 4.05449 9.94519 1.66668 6.99967 1.66668ZM0.333008 7.00001C0.333008 3.31811 3.31778 0.333344 6.99967 0.333344C10.6816 0.333344 13.6663 3.31811 13.6663 7.00001C13.6663 10.6819 10.6816 13.6667 6.99967 13.6667C3.31778 13.6667 0.333008 10.6819 0.333008 7.00001ZM6.99967 3.00001C7.36786 3.00001 7.66634 3.29849 7.66634 3.66668V6.72387L9.99967 8.00001C10.26 8.26036 10.26 8.68247 9.99967 8.94282C9.73932 9.20317 9.31721 9.20317 9.05687 8.94282L6.52827 7.47141C6.40325 7.34639 6.33301 7.17682 6.33301 7.00001V3.66668C6.33301 3.29849 6.63148 3.00001 6.99967 3.00001Z" fill="#6F7287"/>
                        </svg>
                        <span class="f-12 f-c-midgrey" style="padding-left: 4px;">Dibuat {{ $moment(detailKomplain.actual_data.created_at).format('dddd, DD MMM YYYY HH:mm') }}</span>
                    </div>
                </div>
                <div class="separator" />
                <div class="p-4">
                    <div class="d-flex-between-center">
                        <span class="f-16 f-c-midgrey">
                            Customer
                        </span>
                        <span class="f-16">
                            {{ detailKomplain.actual_data.nama_customer }} 
                        </span>
                    </div>
                    <div class="d-flex-between-center">
                        <span class="f-16 f-c-midgrey">
                            Nomor Telepon
                        </span>
                        <span class="f-16">
                            +{{ detailKomplain.actual_data.telp }}
                        </span>
                    </div>
                    <div class="d-flex-between-center">
                        <span class="f-16 f-c-midgrey">
                            Nama Mesin
                        </span>
                        <span class="f-16">
                            {{ detailKomplain.actual_data.snap_mesin.nama }}
                        </span>
                    </div>
                    <div class="d-flex-between-center">
                        <span class="f-16 f-c-midgrey">
                            Id Mesin
                        </span>
                        <span class="f-16">
                            {{ detailKomplain.actual_data.snap_mesin.id }}
                        </span>
                    </div>
                    <div class="d-flex-between-center">
                        <span class="f-16 f-c-midgrey">
                            Waktu Pembayaran
                        </span>
                        <span class="f-16">
                            {{ $moment(detailKomplain.actual_data.waktu_pembayaran).format('dddd, DD MMM YYYY HH:mm') }}
                        </span>
                    </div>
                    <div class="border-bottom my-1"/>
                    <div class="d-flex-between-center">
                        <span class="f-16 f-c-midgrey">
                            Nominal
                        </span>
                        <span class="f-16">
                            {{ detailKomplain.actual_data.total | currency }}
                        </span>
                    </div>
                </div>
                <div class="separator" />
                <div class="p-4">
                    <div class="f-16 f-bold">
                        Informasi Komplain
                    </div>
                    <div>
                        <div class="p-y-8 f-14 f-c-midgrey">
                            Bukti Pembayaran
                        </div>
                        <div v-if="detailKomplain.qris_gagal_documentation.length" class="d-flex over-y-auto" style="gap: 5px">
                            <img
                                v-for="(foto, indexFoto) in detailKomplain.qris_gagal_documentation"
                                :key="indexFoto"
                                width="70"
                                height="70"
                                class="border rounded images"
                                style="object-fit: cover;"
                                :src="'https://storage.googleapis.com/' + foto.cloud_bucket + '/' + (foto.cloud_thumb || foto.cloud_name)"
                                @click="openImage('https://storage.googleapis.com/' + foto.cloud_bucket + '/' + foto.cloud_name, foto.cloud_content_type)"
                            >
                        </div>
                        <div v-else>
                            -
                        </div>
                    </div>
                    <div class="border-bottom my-2"/>
                    <div>
                        <div class="p-y-8 f-14 f-c-midgrey">
                            Keterangan
                        </div>
                        <p class="f-14">
                            {{ detailKomplain.actual_data.keterangan }}
                        </p>
                    </div>
                </div>
                <div class="separator" />
                <div class="p-4">
                    <div class="f-16 f-bold">
                        Riwayat Komplain
                    </div>
                    <div class="p-r-20 tl-wrapper">
                        <SOTimeline v-for="(listTimeLine, index) in timelineData" :key="'listTimeLine'+index">
                            <template v-slot:title>
                                <div id="title" class="d-flex align-items-end">
                                    {{ listTimeLine.historyTitle }}
                                </div>
                            </template>
                            <template v-slot:content>
                                <div>
                                    <div id="subtitle" class="f-14 f-c-midgrey" v-if="listTimeLine.status == '32_done'">
                                        Foto bukti refund
                                    </div>
                                    <div id="subtitle" class="f-14 f-c-midgrey" v-if="listTimeLine.status == '21_process_cs'">
                                        {{ listTimeLine.historySubtitle }} {{ listTimeLine.nama }}
                                    </div>
                                    <div id="subtitle" class="f-14 f-c-midgrey" v-if="listTimeLine.status == '22_process_ewallet'">
                                        {{ listTimeLine.historySubtitle }} {{ listTimeLine.nama }}
                                    </div>
                                    <div id="subtitle" class="f-14 f-c-midgrey" v-else>
                                        {{ listTimeLine.historySubtitle }}
                                    </div>
                                    <template v-if="detailKomplain.qris_gagal_refund_documentation.length && listTimeLine.status == '32_done'">
                                        <div  class="d-flex over-y-auto" style="gap: 5px">
                                            <img
                                                v-for="(foto, indexFoto) in detailKomplain.qris_gagal_refund_documentation"
                                                :key="indexFoto"
                                                width="70"
                                                height="70"
                                                class="border rounded images"
                                                style="object-fit: cover;"
                                                :src="'https://storage.googleapis.com/' + foto.cloud_bucket + '/' + (foto.cloud_thumb || foto.cloud_name)"
                                                @click="openImage('https://storage.googleapis.com/' + foto.cloud_bucket + '/' + foto.cloud_name, foto.cloud_content_type)"
                                            >
                                        </div>
                                    </template>
                                    <div class="f-12 f-c-midgrey">
                                        {{ $moment(listTimeLine.created_at).format('dddd, DD MMM YYYY HH:mm') }}
                                    </div>
                                </div>
                            </template>
                        </SOTimeline>
                    </div>
                </div>
                <div class="separator" />
                <div class="border-bottom">
                    <div
                        v-if="detailKomplain.actual_data.status == '31_need_refund'"
                        @click="goRefundCustomer"
                        class="p-3 border-bottom"
                    >
                        <img src="../../../assets/icons/upload(1).svg" alt="" style="width: 25px;height:25px">
                        <span class="f-16 f-semi p-l-20">Refund Customer</span>
                    </div>
                    <div class="p-3 border-bottom" @click="contact()">
                        <img src="../../../assets/icons/mdi_whatsapp.svg" alt="" style="width: 25px;height:25px">
                        <span class="f-16 f-semi p-l-20">Hubungi Outlet</span>
                    </div>
                </div>
            </div>
        </template>
        <template v-slot:modal>
            <ImagePreview
                ref="imagePreview"
            />
            <RefundCostumer
                ref="modalRefund"
                @success="reloadPage()"
            />
        </template>
    </SOSlotBase>
</template>

<script>
import statusKomplain from '../static/statusKomplain'
import { mapMutations, mapActions } from "vuex";
import { moduleName } from "../store/state";
import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOTimeline from "@/so-components/global/ui/SOTimeline";
import SOIconBase from '@/so-components/global/icons/SOIconBase';
import ExpandArrow1408 from '@/so-components/global/icons/iconPacks/ExpandArrow1408';
import RefundCostumer from '../components/RefundCustomer';
import ImagePreview from "../components/ImagePreview";
import PilihTransakksiHapusModal from "../components/TransaksiHapusModal";

export default {
    name: 'DetailKomplain',
    components: {
        SOSlotBase,
        SOLoadingPage,
        SOTitleBar,
        SOTimeline,
        SOIconBase,
        ExpandArrow1408,
        RefundCostumer,
        ImagePreview,
        PilihTransakksiHapusModal,
    },
    data() {
        return {
            pageSetting: {
                isLoading: false,
            },
            image: {
                show: false,
                url: null
            },
        }
    },
    props: {
        id: {
            type: String,
            default: null,
        },
    },
    computed: {
        detailKomplain() {
            return this.$store.state.komplainQrisModule.detailKomplain
        },
        timelineData () {
            return this.detailKomplain.history_data.map(item => {
                return {
                    ...item,
                    ...statusKomplain.find(status => status.value == item.status),
                }
            })
        },
        idTampil() {
            const size = 7; 
            let final = this.id + "";
            while(final.length < size) final = "0" + final;
            return 'SMTL' + final;
        },
    },
    methods: {
        ...mapActions({
            getDetailKomplain: `${moduleName}/getDetailKomplain`,
            getListAkunRefund: `${moduleName}/getListAkunRefund`
        }),
        ...mapMutations(moduleName, {
            setNeedReload: `setNeedReload`,
        }),
        async init() {
            this.pageSetting.isLoading = true;
            await this.getDetailKomplain(this.id);
            await this.getListAkunRefund(this.detailKomplain.actual_data.idoutlet);
            this.pageSetting.isLoading = false
        },
        contact() {
            window.open("https://Wa.me/" + this.detailKomplain.actual_data.outlet.telp);
        },
        openImage(imgUrl, contentType) {
            this.image.url = imgUrl
            this.$refs.imagePreview.open(this.image.url, contentType)
        },
        reloadPage() {
            this.$refs.modalRefund.closeModal();
            this.init();
        },
        goRefundCustomer() {
            this.$refs.modalRefund.open();
        },
    },
    async mounted() {
        await this.$store.commit('komplainQrisModule/setIdKomplain', this.id)
        this.setNeedReload(false)
        this.init();
    }
}
</script>
<style scoped>
    .tl-wrapper >>> div:first-child > .tl-item .tlx-divider .tlx-point {
        background: #206cff !important;
        box-shadow: 0px 0px 0px 4px rgba(32, 108, 255, 0.15);
    }
    .tl-wrapper >>> div:first-child > .tl-item .tlx-divider .tlx-line {
        background: #206cff !important;
    }
    .tl-wrapper >>> div:first-child > .tl-item .tlx-txt #title:first-child{
        color: #206cff !important;
    }
</style>
